import { render, staticRenderFns } from "./notification-cell.vue?vue&type=template&id=454fbf6c"
import script from "./notification-cell.vue?vue&type=script&lang=js"
export * from "./notification-cell.vue?vue&type=script&lang=js"
import style0 from "./notification-cell.vue?vue&type=style&index=0&id=454fbf6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports